import { render } from "./HealthStatsBloc.vue?vue&type=template&id=c8f91358&scoped=true"
import script from "./HealthStatsBloc.vue?vue&type=script&lang=js"
export * from "./HealthStatsBloc.vue?vue&type=script&lang=js"

import "./HealthStatsBloc.vue?vue&type=style&index=0&id=c8f91358&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8f91358"]])

export default __exports__